import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["prompt", "submit", "result", "output", "error"]

  generate(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)

    this.submitTarget.disabled = true
    
    // Hide previous errors
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
      this.errorTarget.textContent = ''
    }
    
    // Hide previous results
    if (this.hasResultTarget) {
      this.resultTarget.classList.add('hidden')
    }

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(data => {
          throw new Error(data.error || `Server responded with status ${response.status}`)
        })
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        if (this.hasOutputTarget) {
          this.outputTarget.textContent = data.text
        }
        if (this.hasResultTarget) {
          this.resultTarget.classList.remove('hidden')
        }
      } else {
        throw new Error(data.error || 'Unknown error occurred')
      }
    })
    .catch(error => {
      console.error('AI generation error:', error)
      const errorMessage = error.message || 'Ein Fehler ist aufgetreten'
      
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = `❌ Fehler bei der AI-Generierung: ${errorMessage}`
        this.errorTarget.classList.remove('hidden')
      } else if (this.hasOutputTarget) {
        this.outputTarget.textContent = `❌ Fehler: ${errorMessage}`
        if (this.hasResultTarget) {
          this.resultTarget.classList.remove('hidden')
        }
      } else {
        alert(`Fehler bei der AI-Generierung: ${errorMessage}`)
      }
    })
    .finally(() => {
      this.submitTarget.disabled = false
    })
  }

  apply(event) {
    const generatedText = this.outputTarget.textContent
    const targetField = document.querySelector(`[name="profile[${this.targetFieldValue}]"]`)
    if (targetField) {
      targetField.value = generatedText
    }
  }
}